import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";

//COMPONENTS
import Rooms from "./files/rooms";

function PodRouter() {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(true);
    });

    return (
        <div style={{ height: "100%" }}>
            {isLoaded && (
                <div style={{ height: "100%" }}>
                    <Routes>
                        <Route path="/" element={<Rooms />} />
                    </Routes>
                </div>
            )}
        </div>
    );
}

export default PodRouter;
